import { GET_PATIENT_BY_MOBILE_NUMBER } from "@/components/graphql/profiles";
import {
  GetPatientByMobileNumber,
  GetPatientByMobileNumberVariables,
} from "@/components/graphql/types/getPatientByMobileNumber";
import { FetchPatientPayload } from "@/redux/slice/auth/types/FetchPatientPayload";

export default async function fetchPatientApi(fetchPatientPayload: FetchPatientPayload) {
  const { apolloClient, mobileNumber } = fetchPatientPayload;

  return await apolloClient.query<GetPatientByMobileNumber, GetPatientByMobileNumberVariables>({
    query: GET_PATIENT_BY_MOBILE_NUMBER,
    variables: {
      mobileNumber,
    },
    fetchPolicy: "no-cache",
  });
}
